import { lazy } from 'react';

export const TermsLazy = lazy(() => import('./Terms'));
